import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/Product.vue'
import Shop from '../views/Shop.vue'
import Skincare from '../views/Skincare.vue'
import About from '../views/About.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'ACCUEIL'
        }
    },
    {
        path: '/Product',
        name: 'Product',
        component: Product,
        meta: {
            title: 'PRODUITS'
        }
    },
    {
        path: '/Shop',
        name: 'Shop',
        component: Shop,
        meta: {
            title: 'BOUTIQUE'
        }
    },
    {
        path: '/Skincare',
        name: 'Skincare',
        component: Skincare,
        meta: {
            title: 'SOINS VISAGE'
        }
    },
    {
        path: '/About',
        name: 'About',
        component: About,
        meta: {
            title: 'NOTRE HISTOIRE'
        }
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router
